import { render, staticRenderFns } from "./categories-table.vue?vue&type=template&id=32c071ec&scoped=true"
import script from "./categories-table.vue?vue&type=script&lang=js"
export * from "./categories-table.vue?vue&type=script&lang=js"
import style0 from "./categories-table.vue?vue&type=style&index=0&id=32c071ec&prod&lang=scss&scoped=true"
import style1 from "./categories-table.vue?vue&type=style&index=1&id=32c071ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c071ec",
  null
  
)

export default component.exports